import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock5_2 as Block } from "./HomepageBlock5_2";
import { defaultData } from "./HomepageBlock5_2DefaultData";
import { meta } from "./HomepageBlock5_2MetaData";
import imagePreview from "./homepage_block_5_preview.png";

export const HomepageBlock5_2: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta,
};
